import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  standalone: false,
  name: 'bringozPackagesCustomDataDisplay'
})
export class BringozPackagesCustomDataDisplayPipe implements PipeTransform {
  transform(packageItems: any[], packageDynamicColumn: any): string {
    if (!packageItems) {
      packageItems = [];
    }

    let match: any;

    _.forEach(packageItems, (item) => {
      if (!!match) {
        return;
      }
      match = _.find(item.configuredFields || [], (cf) => {
        return cf.id === packageDynamicColumn.id || cf.packageFieldId === packageDynamicColumn.id || cf.fieldName === packageDynamicColumn.title;
      });
    });

    return match?.value || '---';
  }
}
